import { eckoDispatch } from '../utils/analytics';
import { showToast } from './toast';

function getStoryShareUrl(anchor) {
	const url = new URL(window.location.href);
	url.hash = anchor;
	return url.toString();
}

function getPageTitle() {
	return document.querySelector('title')?.textContent?.trim() || document.title || '';
}

function getShareText(storyTitle, pageTitle, url) {
	return `📰 "${storyTitle}" \nFrom ${pageTitle}: \n${url}`;
}

async function copyWithClipboardApi(text) {
	if (!navigator.clipboard?.writeText) {
		throw new Error('Clipboard API unavailable');
	}

	await navigator.clipboard.writeText(text);
}

function copyWithTextarea(text) {
	const textarea = document.createElement('textarea');
	textarea.value = text;
	textarea.setAttribute('readonly', '');
	textarea.style.position = 'fixed';
	textarea.style.top = '-9999px';
	document.body.appendChild(textarea);
	textarea.select();

	let copied = false;

	try {
		copied = document.execCommand('copy');
	} finally {
		textarea.remove();
	}

	if (!copied) {
		throw new Error('Textarea copy failed');
	}
}

async function copyToClipboard(text) {
	try {
		await copyWithClipboardApi(text);
		return;
	} catch (error) {
		copyWithTextarea(text);
	}
}

function dispatchStoryShare(button, anchor) {
	const article = button.closest('.newsletter-story-block');
	eckoDispatch('ecko:storyShare', {
		storyId: article?.getAttribute('data-story-id') || '',
		anchor
	});
}

async function shareStory(button) {
	const anchor = button.getAttribute('data-story-anchor');
	if (!anchor) return;

	const title = button.getAttribute('data-story-title') || document.title;
	const pageTitle = getPageTitle();
	const url = getStoryShareUrl(anchor);
	const shareText = getShareText(title, pageTitle, url);
	const shareData = {
		title,
		text: shareText
	};

	if (navigator.share) {
		try {
			await navigator.share(shareData);
			dispatchStoryShare(button, anchor);
			return;
		} catch (error) {
			if (error?.name === 'AbortError') return;
		}
	}

	try {
		await copyToClipboard(shareText);
		dispatchStoryShare(button, anchor);
		showToast({
			message: 'Link copied to your clipboard. Paste it into a message to share it.',
			mode: 'success',
			icon: 'clipboard',
			duration: 8000
		});
	} catch (error) {
		console.error('Story share copy failed', error);
		showToast({
			message: 'Could not copy link. Please copy it manually.',
			mode: 'error',
			icon: 'alert',
			duration: 8000
		});
	}
}

export function initStoryShare() {
	document.addEventListener('click', event => {
		const button = event.target.closest('[data-story-share]');
		if (!button) return;

		event.preventDefault();
		shareStory(button);
	});
}